import сustomPageScroll from './custom-scroll';
import { isHomePage } from '../helpers/consts';


export default () => {
	const links = Array.from(document.querySelectorAll('a[href*="#"]:not(.scroll-link)')).filter(link => {
    const isSameHostname = link.hostname === window.location.hostname;
    const isInWpAdminBar = link.closest('div#wpadminbar') !== null;

    return isSameHostname && !isInWpAdminBar;
	});

	let thisPageUrl = window.location.origin + window.location.pathname + `/`;
	
	if(thisPageUrl[thisPageUrl.length - 1] === '/') {
		thisPageUrl = thisPageUrl.slice(0, -1);
	}

	links.forEach(link => {
		const href = link.getAttribute('href');
		if(!href.length || href === "#") return;

		const hashPos = href.indexOf('#');
		const pageUrl = href.substring(0, hashPos);
		let targetID = href.substring(hashPos);

		link.addEventListener('click', e => {
			e.preventDefault();

			// console.log(thisPageUrl, pageUrl)
			if(thisPageUrl === pageUrl) {
				const block = document.querySelector(targetID);
				// console.log(`block`,targetID,  block)
				if(!block) return;

				if(isHomePage) {
					сustomPageScroll.scrollToHomeBlock(block);
				} else {
					const rect = block.getBoundingClientRect();
					сustomPageScroll.scroller.scrollTo(0, rect.top, 800);
				}
				history.pushState(null, "", href);
			}
			else {
				// if(targetID && targetID !== '#') {
				// 	sessionStorage.setItem('scrollNextPage', targetID);
				// } else {
				// 	sessionStorage.setItem('scrollNextPage', null);
				// }

				document.location.href = href;
			}
		});
	});
};
